import React from 'react';

import { corporate_landing_path } from '@routes';

const FIRST_TIME_LOGGED_OUT = 'first';

const ForcedLogoutMessage = ({ forcedLogout }: { forcedLogout: string }) => {
  return (
    <div className="flex justify-center">
      <div className="mx-16 mb-32 rounded-4 border-2 border-black bg-secondary-brown-mid/[0.15] px-20 pb-20 pt-2 text-center lg:w-3/6">
        <h3 className="">
          Your account is now enrolled in Magic Link Login—a faster, more secure way to sign in.
        </h3>
        {forcedLogout === FIRST_TIME_LOGGED_OUT ? (
          <>
            <div className="text-[16px]">
              <span className="bold">No More Passwords</span> – Just enter your email, and we’ll
              email you a secure login link.
            </div>
            <div className="text-[16px]">
              <span className="bold">Safe & Secure</span> – Each link is unique and expires after
              one use, keeping your account protected.
            </div>
            <div className="text-[16px]">
              <span className="bold">Fast & Convenient</span> – No need to remember passwords or
              reset them again. Next time you log in, just enter your email and check your inbox for
              a magic link.
            </div>
          </>
        ) : (
          <>
            <div>
              Please enter your email and check your inbox for your passwordless login link.
            </div>
          </>
        )}

        <div className="mt-12 text-[15px] text-grayscale-gray">
          Interested in The Information access for your team?{' '}
          <a className="text-primary-magenta" href={corporate_landing_path()}>
            Learn more about Group Subscriptions
          </a>
          .
        </div>
      </div>
    </div>
  );
};

export default ForcedLogoutMessage;
